import React, { type ReactNode, type CSSProperties } from 'react';

import { getTextColorFromBackground } from '../utils';

interface LabelProps {
    children: ReactNode;
    color?: string;
    sx?: CSSProperties;
}

const Label: React.FC<LabelProps> = ({ children, color = '#DDD', sx }) => {
    sx = {
        padding: '2px 8px',
        borderRadius: '4px',
        display: 'inline-block',
        ...sx,
    };
    return (
        <span
            style={{
                background: color,
                color: getTextColorFromBackground(color),
                ...sx,
            }}
        >
            {children}
        </span>
    );
};

export default Label;
